import React, { useState, useEffect } from "react";

import { transformTableData } from "../utils/dataTransforms";
import { TableWrapper, getCommonTableOptions } from "./TableConfig";

const withTableData = (WrappedComponent, options = {}) => {
    return function WithTableDataComponent({ data, ...props }) {
        const [tableData, setTableData] = useState([]);

        useEffect(() => {
            if (!data || data.length === 0) return;

            const transformedData = transformTableData(data, options.transformOptions);

            if (options.sortBy) {
                transformedData.sort(options.sortBy);
            }

            if (options.postProcess) {
                options.postProcess(transformedData);
            }

            setTableData(transformedData);
        }, [data]);

        return (
            <div className={`mt-12 flex w-full flex-col ${options.className || ""}`}>
                {options.title && <h4 className="pb-2">{options.title}</h4>}
                <WrappedComponent
                    tableData={tableData}
                    TableWrapper={TableWrapper}
                    getCommonTableOptions={getCommonTableOptions}
                    {...props}
                />
            </div>
        );
    };
};

export default withTableData;
